import { action } from 'typesafe-actions'
import { CompanyActionTypes, Company, CompanySelectedPayload } from './types'

// Here we use the `action` helper function provided by `typesafe-actions`.
// This library provides really useful helpers for writing Redux actions in a type-safe manner.
// For more info: https://github.com/piotrwitek/typesafe-actions
export const fetchRequest = () => action(CompanyActionTypes.FETCH_REQUEST)

// Remember, you can also pass parameters into an action creator. Make sure to
// type them properly as well.
export const fetchSuccess = (data: Company[]) => action(CompanyActionTypes.FETCH_SUCCESS, data)
export const clearSelected = () => action(CompanyActionTypes.CLEAR_SELECTED)
export const fetchError = (message: string) => action(CompanyActionTypes.FETCH_ERROR, message)
export const selectCompany = (companyId: number) => action(CompanyActionTypes.SELECT_COMPANY, companyId)

export const editCompany = (company: Company) => action(CompanyActionTypes.EDIT, company)
export const updateCompany = (company: Company) => action(CompanyActionTypes.UPDATE_EDIT, company)
export const companyUpdated = (company: Company) => action(CompanyActionTypes.EDIT_SUCCESS, company)

export const companySelected = (company: Company) => action(CompanyActionTypes.SELECTED, company)